import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

import DashboardHeader from '../../components/DashboardHeader/DashboardHeader';
import TopicCard from '../../components/TopicCard/TopicCard';
import OptionsModal from '../../components/OptionsModal/OptionsModal';

import styles from './Dashboard.module.css';

const Dashboard = () => {
  const { user } = useAuth();

  const [showOptions, setShowOptions] = useState(false);

  const topics = [
    {
      title: 'film-favs',
      description: 'Lieblingsfilme verwalten'
    },
    {
      title: 'music-favs',
      description: 'Musik teilen'
    },
    {
      title: 'family-calendar',
      description: 'Gemeinsame Termine'
    },
    {
      title: 'family-chat',
      description: 'Chat mit der Familie'
    },
    {
      title: 'schwurbler-newsfeed',
      description: 'Newsfeed'
    }
  ];

  return (
    <div className={styles.container}>
      <DashboardHeader
        user={user}
        onOptionsClick={() => setShowOptions(true)}
      />

      <div className={styles.content}>
        <h2 className={styles.heading}>
          {user?.name}-space
        </h2>

        <div className={styles.grid}>
          {topics.map((topic) => (
            <TopicCard
              key={topic.title}
              title={topic.title}
              description={topic.description}
            />
          ))}
        </div>
      </div>

      {showOptions && (
        <OptionsModal
          onClose={() => setShowOptions(false)}
        />
      )}
    </div>
  );
};

export default Dashboard;